import { Injectable } from '@angular/core';
import { OperationsMutations } from './generated/operations-mutations.generated';
import { OrganizationMutations } from './generated/organization-mutations.generated';
import { GraphqlMutationExecutorService } from './graphql-mutation-executor.service';

@Injectable({
  providedIn: 'root',
})
export class GraphQLMutationsService {
  public readonly organization: OrganizationMutations;
  public readonly operations: OperationsMutations;

  constructor(executor: GraphqlMutationExecutorService) {
    this.organization = new OrganizationMutations(executor);
    this.operations = new OperationsMutations(executor);
  }
}
